import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { ADVERTISEMENT } from "@/shared/resource/apis/endpoints";
import { ADVERTISEMENT_INFORMATION } from "@/shared/resource/constants";
import { dateTime } from "@/shared/utills/date";

export const useAdvertiseMentStore = defineStore("advertisement", {
  state: () => ({
    advertisements: {
      list: [],
      totalCount: 0,
      info: [...ADVERTISEMENT_INFORMATION],
    },
  }),
  actions: {
    clearAdvertisements() {
      this.advertisements.list = [];
      this.advertisements.totalCount = 0;
    },
    async fetchAdvertisements({ page = 1, limit = 10, filters = {} }) {
      this.clearAdvertisements();
      const response = await api.get(ADVERTISEMENT.GET_ADVERTISEMENTS, {
        params: { page_no: page, limit, ...filters },
      });
      const data = response?.data?.data || [];
      const formattedData = data.map((item) => ({
        id: item.ad_group_id,
        maxCount: item.max_count,
        imageUrl: item.image_url,
        title: item.title,
        usedCount: item.used_count,
        status: item.is_active,
        createdAt: dateTime.formatDateTime(item.created_at),
        createdBy: item.created_by,
        updatedAt: dateTime.formatDateTime(item.updated_at) || "-",
        updatedBy: item.updated_by || "-",
      }));
      this.setAdvertisements(formattedData, response?.data?.total_entries || 0);
      return formattedData;
    },
    async deleteAdvertisement(id) {
      const response = await api.delete(ADVERTISEMENT.DELETE(id));
      return response.data;
    },
    async addAdvertisement(payload) {
      const response = await api.post(ADVERTISEMENT.POST, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    },
    async getAdvertisementById(id) {
      const response = await api.get(ADVERTISEMENT.GET_BY_ID(id));
      return response.data;
    },
    async getAdvertisementMetrics(id) {
      const response = await api.get(ADVERTISEMENT.GET_METRICS(id));
      return response.data;
    },
    async updateAdvertisement(id, payload) {
      const response = await api.put(ADVERTISEMENT.UPDATE(id), payload);
      return response.data;
    },
    setAdvertisements(advertisements, totalCount) {
      this.advertisements.list = advertisements;
      this.advertisements.totalCount = totalCount;
    },
  },
  getters: {
    getAdvertisements: (state) => state.advertisements,
  },
});
